export default __webpack_public_path__ + "static/media/mywallet_logo.23db2520.svg";